import React from "react"
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common"
import { ItemCard, ItemListCard, Select, WidgetWrapper } from "uxp/components"
import { ContainerProperty, extractContainerProperties } from "../../../common/ui-props/ContainerProperty"
import { TextProperty } from "../../../common/ui-props/TextProperty"
import { DetailsCardProperty } from "./DetailsCardProperty"
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem"
import { ColorProperty, SimpleColorProperty } from "../../../common/ui-props/ColorProperty"
import './DetailsCard.scss';
import { hasValue, parseValue } from "../../../../util"
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData"
import { IAction } from "../../../common/action-editor/ActionEditor"


const defaultFields: any[] = [
    {
        label: 'hvac',
        value1: '250',
        value2: '15'
    },
    {
        label: 'lighting',
        value1: '250',
        value2: '250'
    }
]
const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    const uiProps = props.uiProps || {}
    if(!uiProps.details) uiProps.details = {fields: defaultFields}
    
    const [loading, setLoading] = React.useState(false)
    const [contextData, setContextData] = React.useState<IContextData>({})

    const { isLoading, initialContextData } = useInitialContextData(props, [props?.uiProps?.source])

    const XPRProps: IUIPropertyDefinitionMap = {
        'container': ContainerProperty({
            background: {
                color: ''
            }
        }, 'Background color'),
        'textColor': SimpleColorProperty('Text color', '#424242'),
        'title': TextProperty({
            text: 'Details Card'
        }, 'Title'),
        'details': DetailsCardProperty('Details', uiProps?.details || { fields: defaultFields})
    }

    const containerBG = uiProps?.container?.background?.color || ''
    const textColor = uiProps?.textColor || '#424242'
    const title = uiProps.title?.text || 'Details Card'

    const item: { [lebel: string]: { value1: string, value2: string } } = {}
    for (const d of (uiProps?.details?.fields || [])) {
        item[d.label] = {
            value1: parseValue(d.value1, contextData),
            value2: parseValue(d.value2, contextData)
        }
    }

    React.useEffect(() => {
        setContextData(initialContextData)
        setLoading(isLoading)
    }, [isLoading, initialContextData])


    return <WidgetWrapper className="uxp-details-card-template"
    >
        <SelectableItem
            props={selectUIProps(uiProps, XPRProps, 'container', 'textColor', 'title', 'details')}
            designer={props.designer}
            contextData={contextData}
        >
            <div className="wd-details-card-container" style={{ '--detailsCardTextColor': textColor } as any} >
                <ItemListCard
                    title={title}
                    item={item}
                    fields={Object.keys(item)}
                    renderField={(item, field, key) => {
                        const v1 = item[field].value1
                        const v2 = item[field].value2

                        return (<div className="widget-designer-details-card-details-section" key={key}>
                            <div className="label">{field.toUpperCase()}</div>
                            <div className="value">
                                {hasValue(v1) ? <div className="value-1">{v1}</div> : null}
                                {hasValue(v2) ? <div className="value-2">{v2}</div> : null}
                            </div>
                        </div>)
                    }}
                    backgroundColor={containerBG}
                    className="widget-designer-details-card-item-card"
                />
            </div>

        </SelectableItem>
    </WidgetWrapper>
}

registerCardTemplate({
    id: 'details-card',
    name: 'Details Card',
    template: XPR,
    description: 'Details card'
})